import React from 'react';

import styles from './remainingAccessStyles';

import AccessCounterLine from './AccessCounterLine/accessCounterLine';
import MessageBubbleIcon from 'BuysideSVGs/message_bubble';
import StarIcon from 'BuysideSVGs/star';
import LightBulbIcon from 'BuysideSVGs/lightbulb';
import HandshakeIcon from 'BuysideSVGs/handshake';
import BriefcaseIcon from 'BuysideSVGs/briefcase';
import CoinStack from 'BuysideSVGs/coin_stack';
import QuestionMarkIcon from 'buyside/svgs/question_mark.svg';

const RemainingAccess = ({
  isPaladin,
  accessData,
  quotaData,
  hasPollAnswerQuota,
  canWriteIdeas
}) => {
  const headingText = isPaladin ? 'Your Paladin Quotas' : 'Your Remaining Access';
  return (
    <div className={styles.remainingAccessWrap}>
      <p className={styles.remainingAccessHeading}>{headingText}:</p>
      {isPaladin ? (
        <div>
          <AccessCounterLine title="Ratings" icon={StarIcon} accessData={quotaData('rating')} />
          <AccessCounterLine
            title="Comments"
            icon={MessageBubbleIcon}
            accessData={quotaData('comment')}
          />
          {hasPollAnswerQuota && (
            <AccessCounterLine
              title="Poll Answers"
              icon={QuestionMarkIcon}
              accessData={quotaData('pollAnswer')}
            />
          )}
        </div>
      ) : (
        <div>
          <AccessCounterLine
            title="Research"
            icon={LightBulbIcon}
            accessData={accessData('idea')}
            canWriteIdeas={canWriteIdeas}
          />
          <AccessCounterLine
            title="Cap Intro"
            icon={HandshakeIcon}
            accessData={accessData('capIntro')}
          />
          <AccessCounterLine
            title="Job Vault"
            icon={BriefcaseIcon}
            accessData={accessData('job')}
          />
          <AccessCounterLine
            title="Comp"
            icon={CoinStack}
            accessData={accessData('compensation')}
          />
        </div>
      )}
    </div>
  );
};

export default RemainingAccess;
